import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Linkedin, User } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const Person = ({ p, jury }) => (
  <li className={`border-2 border-[#111] p-4 cv-lift ${jury ? 'bg-[#111] text-[#F5F3EB] shadow-[5px_5px_0_#FF6338]' : 'bg-white shadow-[5px_5px_0_#111]'}`} data-testid={`${jury ? 'jury' : 'mentor'}-card-${p.id}`}>
    <div className={`aspect-square border-2 overflow-hidden flex items-center justify-center ${jury ? 'border-[#F5F3EB] bg-[#365CFF]' : 'border-[#111] bg-[#D7FF38]'}`}>
      {p.photo_url ? <img src={`${API}${p.photo_url}`} alt={p.name} className="w-full h-full object-cover" loading="lazy" /> : <User size={52} />}
    </div>
    <p className="mt-3 cv-display text-sm sm:text-lg font-extrabold uppercase leading-tight [overflow-wrap:anywhere] sm:[overflow-wrap:normal]">{p.name}</p>
    {(p.title || p.company) && <p className="text-xs font-medium mt-1 opacity-80">{[p.title, p.company].filter(Boolean).join(' · ')}</p>}
    {p.linkedin_url && (
      <a href={p.linkedin_url} target="_blank" rel="noopener noreferrer" className={`mt-3 inline-flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-wider border-2 px-2 py-1 transition-colors ${jury ? 'border-[#F5F3EB] hover:bg-[#FF6338] hover:text-[#111]' : 'border-[#111] hover:bg-[#D7FF38]'}`}>
        <Linkedin size={12} /> LinkedIn<span className="sr-only"> profile of {p.name} (opens in new tab)</span>
      </a>
    )}
  </li>
);

const Group = ({ title, people, jury }) => people.length > 0 && (
  <div className="mt-10" data-testid={`${jury ? 'jury' : 'mentors'}-grid`}>
    <h3 className="cv-display text-3xl sm:text-4xl font-extrabold uppercase">{title}</h3>
    <ul className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">{people.map((p) => <Person key={p.id} p={p} jury={jury} />)}</ul>
  </div>
);

// Hidden entirely until at least one mentor or jury member is published.
export const ConvergeMentors = () => {
  const [people, setPeople] = useState({ mentor: [], jury: [] });
  useEffect(() => {
    Promise.all(['mentor', 'jury'].map((r) => axios.get(`${API}/api/public/converge/speakers?role=${r}`).then((x) => x.data.speakers).catch(() => [])))
      .then(([mentor, jury]) => setPeople({ mentor, jury }));
  }, []);
  if (!people.mentor.length && !people.jury.length) return null;
  return (
    <section id="mentors" className="scroll-mt-20 border-b-2 border-[#111]" data-testid="mentors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <p className="text-xs font-bold uppercase tracking-[0.25em]">[ 04.5 ] People</p>
        <h2 className="cv-display font-extrabold uppercase leading-[0.9] mt-3 text-[2.3rem] sm:text-7xl break-words">Mentors <span className="cv-outline">&amp;</span> jury.</h2>
        <Group title="Mentors" people={people.mentor} />
        <Group title="Jury" people={people.jury} jury />
      </div>
    </section>
  );
};
